import React from 'react';
import styles from './OrderPage.m.sass';
import content from '../../components/content/Content.m.sass';

import {browserHistory} from 'react-router';
import {connect} from 'react-redux';

import {getOrder, getOrderPaymentData} from '../../ducks/order';

import extractGaClientId from '../../utils/extractGaClientId';

import Meta from '../../components/meta/Meta';
import Content from '../../components/content/Content';
import BreadcrumbsContainer from '../breadcrumbsContainer/BreadcrumbsContainer';
import TrustPilot from '../../components/trustPilot/TrustPilot';
import OnlineSupport from '../../components/onlineSupport/OnlineSupport';
import CartProduct from '../../components/cartProduct/CartProduct';
import Pricing from '../../components/pricing/Pricing';
import withMediaQueries from '../withMediaQueries/withMediaQueries';
import GoBack from '../../components/goBack/GoBack';
import Loader from '../../components/loader/Loader';
import Button from "../../components/button/Button";

@withMediaQueries({collapsed: '(max-width: 991px)'}, {collapsed: false})
@connect()
export default class OrderPage extends React.PureComponent {
  static getOrderUrl = ({id, tokenValue, anonymous}, fromPaymentGateway) => {
    let url = process.env.PUBLIC_URL + '/order/' + id;

    if (anonymous) {
      url += '/' + tokenValue;
    }

    if (fromPaymentGateway) {
      url += '?fromPaymentGateway=yes'
    }

    return url;
  };

  constructor(props) {
    super(props);

    this.state = {order: undefined};
  }

  retryPayment = (order) => this.props.dispatch(getOrderPaymentData(
    order.id,
    order.tokenValue,
    OrderPage.getOrderUrl(order, true),
    extractGaClientId()
  )).then(paymentDataResponse => window.location = paymentDataResponse.content.url);

  componentDidMount() {
    const {params, location, dispatch} = this.props;
    const {fromPaymentGateway} = location.query;

    if (fromPaymentGateway) {
      browserHistory.replace(location.pathname);
    }

    dispatch(getOrder(params.orderId, params.orderToken))
      .then(orderResponse => {
        if (fromPaymentGateway && orderResponse.content.state === 'fulfilled') {
          //dispatch(analyticsTransaction(orderResponse.content));
        }

        this.setState({order: orderResponse.content});
      }, () => this.setState({order: false}));
  }

  render() {
    const {collapsed} = this.props;
    const {order} = this.state;

    if (!order) {
      return <Loader page/>;
    }

    return (
      <div>
        <Meta
          fallbackTitle={`Order #${order.number}`}
        />

        {collapsed && (
          <GoBack/>
        )}

        <Content>
          {!collapsed && (
            <div className={content.content_top}>
              <div className="container">
                <BreadcrumbsContainer
                  append={[{name: `Order #${order.number}`}]}
                  only
                />
              </div>
            </div>
          )}

          <div className="container">
            <div className={content.content_inner}>
              {order.state !== 'fulfilled' ? (
                <div className={styles.orderPage_failed}>
                  <h1 className={content.content_header}>Transaction failed</h1>

                  <div className={styles.orderPage_failedText}>
                    <p>Possible solutions:</p>
                    <ul>
                      <li>Make sure your <a href="#">paypal account is active</a> as well as the card connected to it</li>
                      <li>Make sure <a href="#">you didn't cancel your payment</a></li>
                      <li>It's rare but it could be a <a href="#">temporary Technical issue at Paypal</a></li>
                    </ul>
                    <p>If nothing helps or you wish to pay with another method, please <a href="#">contact our Support</a>.</p>
                  </div>

                  <div className={styles.order}>
                    <div className={styles.order_wrapper}>
                      <div className={styles.order_heading}>
                        <span className={styles.order_name}>Order #{order.number}</span>
                        <span className={styles.order_price}>
                          <Pricing
                            value={order.total}
                            accent
                          />
                        </span>
                      </div>

                      <div className={styles.order_inner}>
                        {order.items.map(item => (
                          <CartProduct
                            key={item.id}
                            name={CartProduct.getItemTitle(item)}
                            price={item.total}
                          />
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className={styles.orderPage_failedActions}>
                    <Button big onClick={() => this.retryPayment(order)}>Try again</Button>
                  </div>
                </div>
              ) : (
                <React.Fragment>
                  <h1 className={content.content_header}>Thanks for your order!</h1>

                  <div className="row">
                    <div className="col-md-7">
                      <div className={content.content_text}>
                        <p>Hello, thank you for choosing us. You can contact us via site-chat or skype (<a href="skype:live:boosters4gamers?chat" target="_blank" rel="nofollow">live:boosters4gamers</a>) or discord (<a href="https://discord.gg/WVYyYuT" target="_blank" rel="nofollow">https://discord.gg/WVYyYuT</a>) or we will contact with you in few minutes. We are always glad to see you again!</p>
                      </div>
                    </div>
                  </div>

                  <div className={styles.orderPage_content}>
                    <div className={styles.orderPage_orderCol}>
                      <div className={styles.order}>
                        <div className={styles.order_wrapper}>
                          <div className={styles.order_heading}>
                            <span className={styles.order_name}>Order #{order.number}</span>
                            <span className={styles.order_price}>
                              <Pricing
                                value={order.total}
                                accent
                              />
                            </span>
                          </div>

                          <div className={styles.order_inner}>
                            {order.items.map(item => (
                              <CartProduct
                                key={item.id}
                                name={CartProduct.getItemTitle(item)}
                                price={item.total}
                              />
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className={styles.orderPage_col}>
                      <OnlineSupport/>
                    </div>

                    <div className={styles.orderPage_col}>
                      <TrustPilot apart/>
                    </div>
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
        </Content>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/orderPage/OrderPage.js